export class StudyReportTemplateEdit {
  public Id: number;
  public Name: string;
  public Text: string;
  public PhysicianIds: number[];
  public PracticeRegionIds: number[];
  public EditorId: number;
}
